// Signature checks identify the container only; they do not extract or scan its contents.
const signatures = {
  zip: [[0x50, 0x4b, 0x03, 0x04], [0x50, 0x4b, 0x05, 0x06], [0x50, 0x4b, 0x07, 0x08]],
  rar: [[0x52, 0x61, 0x72, 0x21, 0x1a, 0x07, 0x00], [0x52, 0x61, 0x72, 0x21, 0x1a, 0x07, 0x01, 0x00]],
  "7z": [[0x37, 0x7a, 0xbc, 0xaf, 0x27, 0x1c]],
};
export function archiveType(name = "") {
  const extension = name.split(".").pop().toLowerCase();
  return Object.prototype.hasOwnProperty.call(signatures, extension) ? extension : null;
}
export function matchesArchiveSignature(name, bytes) {
  const type = archiveType(name);
  return !type || signatures[type].some(signature => signature.every((byte, index) => bytes[index] === byte));
}
export async function validateArchiveFiles(files) {
  for (const file of files) {
    const type = archiveType(file.name);
    if (!type) continue;
    const bytes = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(new Uint8Array(reader.result));
      reader.onerror = () => reject(new Error(`Cannot read ${file.name}. Select the file again.`, { cause: "logical" }));
      reader.readAsArrayBuffer(file.slice(0, 8));
    });
    if (!matchesArchiveSignature(file.name, bytes)) {
      throw new Error(`${file.name} does not match the ${type.toUpperCase()} format. Compress the original folder again; do not just rename its extension.`, { cause: "logical" });
    }
  }
}
